module.exports = __webpack_public_path__ + "img/pellets-pallet-yellow.837051c.svg";